exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-block[data-v-340b2da4]{border:0 solid;display:inline-block;min-width:75px;margin-right:15px!important;text-align:center}.my-badge[data-v-340b2da4]{float:left!important;margin-left:0!important;min-width:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-340b2da4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/common/Paginacao.vue
// module id = 87wQ
// module chunks = 0 1 24 25 26